import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <span className="inline-flex items-center gap-3 text-[11px] font-bold uppercase tracking-[0.35em] text-gold">
    <span className="h-px w-10 bg-gold/70" />
    {children}
  </span>
);
